<template>
    <div class="user-edit">
        <data-form title="Reset Password"
                   tag="user-password"
                   save-button-label="Save"
                   :field-model="userFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/user/view/${userId}`"
                   submit-success-message="Password updated"
                   submit-error-message="Error updating user password"
                   :submit-success-route="`/user/view/${userId}`">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'

export default Vue.extend({
    name: 'UserPassword',
    props: {
        userId: {
            type: Number,
            required: true
        },
    },
    data () {
        return {
            userFields: UserFields,
            fieldGroups: [
                ['id', 'password']
            ]
        }
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.userId)
        },
        onSubmit (modelInstance) {
            return this.$api.userPassword(this, this.userId, modelInstance.password)
        }
    },
    created () {
        this.$api.getItem(this, 'user', this.userId)
            .then((data) => {
                this.userInfo = data
            })
    },
})

</script>

